export default __webpack_public_path__ + "static/media/hero2.86456bb2.png";